// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"ContentCardList_cardWrapper__TSzU7","cardWrapperSmall":"ContentCardList_cardWrapperSmall__qBGev"};